"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
__export(require("./file-upload/file-select.directive"));
__export(require("./file-upload/file-drop.directive"));
__export(require("./file-upload/file-uploader.class"));
__export(require("./file-upload/file-item.class"));
__export(require("./file-upload/file-like-object.class"));
var file_upload_module_1 = require("./file-upload/file-upload.module");
exports.FileUploadModule = file_upload_module_1.FileUploadModule;



//////////////////
// WEBPACK FOOTER
// ./~/ng2-file-upload/index.js
// module id = 280
// module chunks = 1